import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ApplicationFlow } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow';
import { hash } from 'rsvp';

const { SUCCEEDED } = ApplicationFlow.Status;

export default class AccountOpenRoute extends Route {
  @service currentApplicationFlow;
  @service sfsAccountApi;
  @service sentry;

  beforeModel() {
    if (this.currentApplicationFlow.status !== SUCCEEDED) {
      this.replaceWith('signup.please-wait');
    }
  }

  model() {
    return hash({
      accountDetails: this.sfsAccountApi.retrieveAccountDetails(
        this.currentApplicationFlow.accountId
      ),
    });
  }
}
